import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Phone, MessageCircle, Mail, MapPin, Clock, Send, CheckCircle } from 'lucide-react';
export function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    service: '',
    message: ''
  });
  const [isSubmitted, setIsSubmitted] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Form submission logic would go here
    setIsSubmitted(true);
    setTimeout(() => {
      setIsSubmitted(false);
      setFormData({
        name: '',
        email: '',
        phone: '',
        service: '',
        message: ''
      });
    }, 3000);
  };
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    setFormData(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };
  return <section id="contact" className="py-24 px-4 sm:px-6 lg:px-8 bg-black-rich border-t border-gray-900 relative overflow-hidden" data-id="element-52">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] bg-gold-600/5 rounded-full blur-[100px]" data-id="element-53" />

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-54">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-55">
          <span className="text-gold-500 font-medium tracking-widest uppercase text-sm" data-id="element-56">
            Get In Touch
          </span>
          <h2 className="text-3xl md:text-5xl font-bold text-white mt-3 mb-6" data-id="element-57">
            Contact Kings Gold Smelters
          </h2>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto" data-id="element-58">
            We are always ready to assist you with professional gold smelting
            services. Book your appointment today.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 mb-16" data-id="element-59">
          {/* Contact Info Cards */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="bg-black-light border border-gray-800 p-8 rounded-lg text-center hover:border-gold-500/30 transition-colors" data-id="element-60">
            <div className="w-12 h-12 bg-gray-900 rounded-full flex items-center justify-center mx-auto mb-6 text-gold-500" data-id="element-61">
              <MapPin className="w-6 h-6" data-id="element-62" />
            </div>
            <h3 className="text-xl font-bold text-white mb-2" data-id="element-63">Our Location</h3>
            <p className="text-gray-400" data-id="element-64">Bagamoyo Road</p>
            <p className="text-gray-400" data-id="element-65">Dar es Salaam, Tanzania</p>
            <p className="text-gray-500 text-sm mt-4" data-id="element-66">P.O. Box 684</p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="bg-black-light border border-gray-800 p-8 rounded-lg text-center hover:border-gold-500/30 transition-colors" data-id="element-67">
            <div className="w-12 h-12 bg-gray-900 rounded-full flex items-center justify-center mx-auto mb-6 text-gold-500" data-id="element-68">
              <Mail className="w-6 h-6" data-id="element-69" />
            </div>
            <h3 className="text-xl font-bold text-white mb-2" data-id="element-70">Email Us</h3>
            <p className="text-gray-400 mb-4" data-id="element-71">For inquiries and quotes</p>
            <a href="mailto:kingsgoldsmelters@gmail.com" className="text-gold-400 hover:text-white transition-colors font-medium" data-id="element-72">
              kingsgoldsmelters@gmail.com
            </a>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.3
        }} className="bg-black-light border border-gray-800 p-8 rounded-lg text-center hover:border-gold-500/30 transition-colors" data-id="element-73">
            <div className="w-12 h-12 bg-gray-900 rounded-full flex items-center justify-center mx-auto mb-6 text-gold-500" data-id="element-74">
              <Clock className="w-6 h-6" data-id="element-75" />
            </div>
            <h3 className="text-xl font-bold text-white mb-2" data-id="element-76">Working Hours</h3>
            <p className="text-gray-400" data-id="element-77">Monday - Saturday</p>
            <p className="text-gray-400" data-id="element-78">8:00 AM - 6:00 PM</p>
            <p className="text-gray-500 text-sm mt-4" data-id="element-79">Sunday: Closed</p>
          </motion.div>
        </div>

        {/* Contact Form and Quick Contact Section */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-16" data-id="element-80">
          {/* Contact Form */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-black-light border border-gray-800 rounded-lg p-8" data-id="element-81">
            <h3 className="text-2xl font-bold text-white mb-6" data-id="element-82">
              Send Us a Message
            </h3>

            {isSubmitted ? <motion.div initial={{
            opacity: 0,
            scale: 0.9
          }} animate={{
            opacity: 1,
            scale: 1
          }} className="flex flex-col items-center justify-center py-12" data-id="element-83">
                <div className="w-16 h-16 bg-green-500/20 rounded-full flex items-center justify-center mb-4" data-id="element-84">
                  <CheckCircle className="w-8 h-8 text-green-500" data-id="element-85" />
                </div>
                <h4 className="text-xl font-bold text-white mb-2" data-id="element-86">
                  Message Sent!
                </h4>
                <p className="text-gray-400 text-center" data-id="element-87">
                  We'll get back to you shortly.
                </p>
              </motion.div> : <form onSubmit={handleSubmit} className="space-y-6" data-id="element-88">
                <div data-id="element-89">
                  <label htmlFor="name" className="block text-sm font-medium text-gray-300 mb-2" data-id="element-90">
                    Full Name *
                  </label>
                  <input type="text" id="name" name="name" required value={formData.name} onChange={handleChange} className="w-full bg-gray-900 border border-gray-700 rounded-lg px-4 py-3 text-white placeholder-gray-500 focus:outline-none focus:border-gold-500 transition-colors" placeholder="John Doe" data-id="element-91" />
                </div>

                <div data-id="element-92">
                  <label htmlFor="email" className="block text-sm font-medium text-gray-300 mb-2" data-id="element-93">
                    Email Address *
                  </label>
                  <input type="email" id="email" name="email" required value={formData.email} onChange={handleChange} className="w-full bg-gray-900 border border-gray-700 rounded-lg px-4 py-3 text-white placeholder-gray-500 focus:outline-none focus:border-gold-500 transition-colors" placeholder="john@example.com" data-id="element-94" />
                </div>

                <div data-id="element-95">
                  <label htmlFor="phone" className="block text-sm font-medium text-gray-300 mb-2" data-id="element-96">
                    Phone Number *
                  </label>
                  <input type="tel" id="phone" name="phone" required value={formData.phone} onChange={handleChange} className="w-full bg-gray-900 border border-gray-700 rounded-lg px-4 py-3 text-white placeholder-gray-500 focus:outline-none focus:border-gold-500 transition-colors" placeholder="+255 XXX XXX XXX" data-id="element-97" />
                </div>

                <div data-id="element-98">
                  <label htmlFor="service" className="block text-sm font-medium text-gray-300 mb-2" data-id="element-99">
                    Service Interested In *
                  </label>
                  <select id="service" name="service" required value={formData.service} onChange={handleChange} className="w-full bg-gray-900 border border-gray-700 rounded-lg px-4 py-3 text-white focus:outline-none focus:border-gold-500 transition-colors" data-id="element-100">
                    <option value="" data-id="element-101">Select a service</option>
                    <option value="onsite" data-id="element-102">On-Site Gold Smelting</option>
                    <option value="mobile" data-id="element-103">Mobile Smelting Service</option>
                    <option value="consultation" data-id="element-104">
                      Professional Consultation
                    </option>
                  </select>
                </div>

                <div data-id="element-105">
                  <label htmlFor="message" className="block text-sm font-medium text-gray-300 mb-2" data-id="element-106">
                    Message *
                  </label>
                  <textarea id="message" name="message" required value={formData.message} onChange={handleChange} rows={4} className="w-full bg-gray-900 border border-gray-700 rounded-lg px-4 py-3 text-white placeholder-gray-500 focus:outline-none focus:border-gold-500 transition-colors resize-none" placeholder="Tell us about your smelting needs..." data-id="element-107" />
                </div>

                <motion.button type="submit" whileHover={{
              scale: 1.02
            }} whileTap={{
              scale: 0.98
            }} className="w-full bg-gold-500 hover:bg-gold-400 text-black font-bold py-4 px-6 rounded-lg transition-colors flex items-center justify-center gap-2" data-id="element-108">
                  <Send className="w-5 h-5" data-id="element-109" />
                  <span data-id="element-110">Send Message</span>
                </motion.button>
              </form>}
          </motion.div>

          {/* Quick Contact Options */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="space-y-6" data-id="element-111">
            <div className="bg-gradient-to-br from-gray-900 to-black border border-gray-800 rounded-lg p-8" data-id="element-112">
              <h3 className="text-2xl font-bold text-white mb-4" data-id="element-113">
                Prefer Instant Contact?
              </h3>
              <p className="text-gray-400 mb-8" data-id="element-114">
                Get immediate assistance through WhatsApp or phone call. Our
                team is ready to help you.
              </p>

              <div className="space-y-4" data-id="element-115">
                <motion.a href="https://wa.me/255797125792" target="_blank" rel="noopener noreferrer" whileHover={{
                scale: 1.02
              }} whileTap={{
                scale: 0.98
              }} className="flex items-center justify-center gap-3 bg-[#25D366] text-white px-6 py-4 rounded-lg font-bold text-lg shadow-lg hover:bg-[#20bd5a] transition-colors w-full" data-id="element-116">
                  <MessageCircle className="w-6 h-6" data-id="element-117" />
                  <span data-id="element-118">WhatsApp Chat</span>
                </motion.a>

                <motion.a href="tel:+255797125792" whileHover={{
                scale: 1.02
              }} whileTap={{
                scale: 0.98
              }} className="flex items-center justify-center gap-3 bg-gradient-to-r from-gold-500 to-gold-600 text-black px-6 py-4 rounded-lg font-bold text-lg shadow-lg hover:from-gold-400 hover:to-gold-500 transition-all w-full" data-id="element-119">
                  <Phone className="w-6 h-6" data-id="element-120" />
                  <span data-id="element-121">Call Us Now</span>
                </motion.a>
              </div>
            </div>

            <div className="bg-black-light border border-gray-800 rounded-lg p-8" data-id="element-122">
              <h4 className="text-xl font-bold text-white mb-4" data-id="element-123">
                Why Contact Us?
              </h4>
              <ul className="space-y-3 text-gray-400" data-id="element-124">
                <li className="flex items-start gap-2" data-id="element-125">
                  <CheckCircle className="w-5 h-5 text-gold-500 flex-shrink-0 mt-0.5" data-id="element-126" />
                  <span data-id="element-127">Free consultation and quotes</span>
                </li>
                <li className="flex items-start gap-2" data-id="element-128">
                  <CheckCircle className="w-5 h-5 text-gold-500 flex-shrink-0 mt-0.5" data-id="element-129" />
                  <span data-id="element-130">Fast response within 24 hours</span>
                </li>
                <li className="flex items-start gap-2" data-id="element-131">
                  <CheckCircle className="w-5 h-5 text-gold-500 flex-shrink-0 mt-0.5" data-id="element-132" />
                  <span data-id="element-133">Professional guidance from experts</span>
                </li>
                <li className="flex items-start gap-2" data-id="element-134">
                  <CheckCircle className="w-5 h-5 text-gold-500 flex-shrink-0 mt-0.5" data-id="element-135" />
                  <span data-id="element-136">Flexible scheduling options</span>
                </li>
              </ul>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}